import React, { useContext, useState, useEffect } from 'react';
import '../App.css'
import { SystemProfile } from '../contexts/SystemContext';
import { Alert } from '@mui/material';


const Erro = (props) => {
    const [systemData, setSystemData] = useContext(SystemProfile)
    const [showErro, setShowErro] = useState(false)
    const erro = systemData?.erro
    const erroType = systemData?.typeError
    const logged  = systemData?.logged
    
    useEffect(()=>{
        if(erro != '') {
            setShowErro(true)
        }
       setTimeout(() => {
            setShowErro(false)
            setSystemData({...systemData, logged: logged, erro: '', typeError: ''})
        }, 4000)
    }, [erro])

    return(
        showErro ? 
                (() => {
                    switch (erroType) {
                      case 'error': return <Alert severity="error">{systemData.erro}</Alert>
                      case 'warning': return <Alert severity="warning">{systemData.erro}</Alert>
                      case 'display': return <Alert severity="info">{systemData.erro}</Alert>
                      case 'success': return <Alert severity="success">{systemData.erro}</Alert>
                      default:
                        return(<></>)
                    }
                })()
            
                
        : null
    )
              
}

export default Erro
